export const SELECAO_INSTITUCIONAL_PERGAMUM = "SELECAO_INSTITUCIONAL_PERGAMUM";
export const SOMENTE_INSTITUCIONAL = "SOMENTE_INSTITUCIONAL";